import React from "react";

import atttendanceImg from "../../assets/img/apponboarding/attendance.png";
import createJobImg from "../../assets/img/apponboarding/create-job.png";
import createTaskImg from "../../assets/img/apponboarding/create_task.png";
import customerImg from "../../assets/img/apponboarding/customer.png";
import InvoiceImg from "../../assets/img/apponboarding/invoice_feature_discovery.png";
import memberImg from "../../assets/img/apponboarding/member.png";
import organizationImg from "../../assets/img/apponboarding/organization.png";
import routeOptImg from "../../assets/img/apponboarding/route_opt.png";
import scheduleImg from "../../assets/img/apponboarding/schedule.svg";
import { getYouTubeVideoId, isYouTubeUrl } from "../../utils/helper";
import {
  ActionsRow,
  Container,
  Description,
  HeaderSection,
  PlayButtonOverlay,
  PlayButtonWrapper,
  PlayIcon,
  PrimaryActionButton,
  SecondaryActionButton,
  Title,
  TitleDescriptionWrapper,
  VideoImage,
  VideoSectionContainer,
} from "./AppOnboardingIndividualPage.styles";

// Mock data for different pages
const getPageContent = isOperationType => ({
  members: {
    featureName: "team_member",
    title: "Expand Your Team in Seconds",
    description:
      "Invite technicians and office staff to your organization. Assign roles, set permissions, and get everyone synced so you can stop micromanaging and start growing.",
    videoUrl: "https://www.youtube.com/watch?v=x9YsnYAr_LE",
    buttonText: "Invite Members",
    onClickPath: "/user/member-invitation",
    backgroundColor: "#EDF8FE",
    backgroundImage: memberImg,
  },
  attendance: {
    featureName: "attendance",
    title: "Your team is missing its crew!",
    description: `Add your employees to start tracking attendance and assigning ${
      isOperationType ? "tasks" : "jobs"
    }. Once they're in, you’ll see exactly who’s on the clock and what’s getting done, all in one place.`,
    videoUrl: "https://youtu.be/54cLSr_9HZ8",
    buttonText: "Add Members",
    onClickPath: "/user/member-invitation",
    backgroundColor: "#EDF8FE",
    backgroundImage: atttendanceImg,
  },
  customer: {
    featureName: "customer",
    title: "Build Your Customer Directory",
    description:
      "Keep every detail at your fingertips. Store contact info, service history, and multiple locations for every client so your team arrives prepared and your customers stay happy.",
    videoUrl: "https://www.youtube.com/watch?v=0ipv-E8p_U0",
    buttonText: "Create Customer",
    onClickPath: "/user/add-customer",
    backgroundColor: "#F4ECFE",
    backgroundImage: customerImg,
  },
  "create-job": {
    featureName: "job",
    title: `Get started with Quick ${isOperationType ? "Tasks" : "Jobs"}`,
    description:
      "Plan, manage and track all your team's tasks in one place, whether you’re in the office or on-the-go.",
    videoUrl: "https://www.youtube.com/watch?v=4Ox9TCQSLxw",
    buttonText: `Create ${isOperationType ? "Task" : "Job"} `,
    onClickPath: isOperationType ? "/user/create-task" : "/user/create-job",
    backgroundColor: "#FAF5F2",
    backgroundImage: isOperationType ? createTaskImg : createJobImg,
  },
  schedule: {
    featureName: "schedule",
    title: `Schedule ${isOperationType ? "Tasks" : "Job"}  Efficiently`,
    description: isOperationType
      ? "Plan your team's schedule and manage all operation tasks in one calendar view"
      : "Plan and manage all service jobs in one calendar view",
    videoUrl: isOperationType
      ? "https://www.youtube.com/watch?v=UeBf9UI4E0I&feature=youtu.be"
      : "https://www.youtube.com/watch?v=I1c3J8at1bI",
    buttonText: "Schedule Now",
    onClickPath: "/user/shift-and-schedule",
    backgroundColor: "#A7C2F9",
    backgroundImage: scheduleImg,
  },
  invoice: {
    featureName: "invoice",
    title: "You've done hard part, now get paid",
    description:
      "Don't let invoicing feel like a chore. Turn your completed jobs into professional bills in a few taps. It's the fastest way to get that \"Payment Received\" notification.",
    videoUrl: "https://www.youtube.com/watch?v=eyJdafRGmSs",
    buttonText: "Create Invoice",
    onClickPath: "/user/create-invoice",
    backgroundColor: "#EDF8FE",
    backgroundImage: InvoiceImg,
  },
  "route-optimization": {
    featureName: "route_optimization",
    title: "Increase work efficiency with route optimization",
    description:
      "Visually route the days work for your team and assign incoming jobs to the closest team member on the map",
    videoUrl: "https://youtu.be/6Mc5IDbKZXU",
    buttonText: "Start Optimizing",
    onClickPath: "route-optimization-modal",
    backgroundColor: "whitesmoke",
    backgroundImage: routeOptImg,
  },
  organization: {
    featureName: "organization",
    title: "Start your organization in seconds",
    description:
      "You've got a business to run—we're just here to make it easier. Enter your company details to unlock professional invoicing, real-time tracking, and effortless team management.",
    videoUrl: "https://youtu.be/IAVqFE97K1o",
    buttonText: "Explore",
    onClickPath: "organization-complete",
    backgroundColor: "#EDF8FE",
    backgroundImage: organizationImg,
  },
});

const AppOnboardingIndividualPage = ({
  history,
  page,
  selectedOrganization,
  appOnboardingState,
  dismissOnboardingFeature,
  dismissFeatureLoading,
  onPrimaryButtonClick,
}) => {
  const orgType = selectedOrganization?.type || "operation";
  const isOperationType = orgType === "operation";
  const [isVideoPlaying, setIsVideoPlaying] = React.useState(false);
  // Get current page content, default to members
  const pageContent = getPageContent(isOperationType);
  const currentContent = pageContent[page];

  const handleButtonClick = () => {
    if (!currentContent) return;

    // If a custom primary button handler is provided, use it
    if (onPrimaryButtonClick) {
      onPrimaryButtonClick();
      return;
    }

    // if (page === "schedule") {
    //   handleDismiss();
    // } else

    if (page === "route-optimization") {
      // Open Optimize Routes modal and dismiss onboarding
      if (
        history &&
        currentContent.onClickPath === "route-optimization-modal"
      ) {
        // Dispatch action to open the modal (you may need to pass this as a prop)
        handleDismiss();
        // The parent component should handle opening the modal
      }
    } else if (page === "organization") {
      // Dismiss onboarding and mark as complete
      handleDismiss();
      // Parent component can handle API call to mark organization setup as complete
    } else {
      if (history && currentContent.onClickPath) {
        history.push(currentContent.onClickPath);
      }
    }
  };

  const handleDismiss = () => {
    if (dismissOnboardingFeature && currentContent?.featureName) {
      dismissOnboardingFeature(
        selectedOrganization?.id,
        currentContent.featureName,
      );
    } else {
      console.warn(
        "Cannot dismiss: missing dismissOnboardingFeature or featureName",
        {
          hasDismissFunction: !!dismissOnboardingFeature,
          hasFeatureName: !!currentContent?.featureName,
        },
      );
    }
  };

  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  // Guard clause: if currentContent is not found, return null
  if (!currentContent) {
    console.warn(`AppOnboarding page "${page}" not found in pageContent`);
    return null;
  }

  return (
    <Container>
      <HeaderSection>
        <TitleDescriptionWrapper>
          <Title>{currentContent.title}</Title>
          <Description>{currentContent.description}</Description>
        </TitleDescriptionWrapper>

        <ActionsRow>
          {page !== "schedule" && (
            <SecondaryActionButton
              onClick={handleDismiss}
              disabled={dismissFeatureLoading}
            >
              {dismissFeatureLoading ? "Dismissing..." : "Dismiss"}
            </SecondaryActionButton>
          )}
          <PrimaryActionButton onClick={handleButtonClick}>
            {currentContent.buttonText}
          </PrimaryActionButton>
        </ActionsRow>
      </HeaderSection>

      <VideoSectionContainer
        style={{
          backgroundColor: currentContent.backgroundColor,
        }}
      >
        {!isVideoPlaying ? (
          <>
            {currentContent.backgroundImage && (
              <img
                src={currentContent.backgroundImage}
                alt="Feature preview"
                style={{
                  maxWidth: "80%",
                  maxHeight: "80%",
                  objectFit: "contain",
                }}
              />
            )}
            <PlayButtonOverlay onClick={handlePlayVideo}>
              <PlayButtonWrapper>
                <PlayIcon />
              </PlayButtonWrapper>
            </PlayButtonOverlay>
          </>
        ) : isYouTubeUrl(currentContent.videoUrl) ? (
          <iframe
            title="Feature video"
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
              currentContent.videoUrl,
            )}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        ) : (
          <video
            src={currentContent.videoUrl}
            autoPlay
            controls
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
            onEnded={() => setIsVideoPlaying(false)}
          />
        )}
      </VideoSectionContainer>
    </Container>
  );
};

export default AppOnboardingIndividualPage;
